import React from 'react'
import { trans } from '../../../../_providers/Translation'
import DatePicker from '@/components/partials/Date'
import popupDefaultHeadImage from "@/assets/img/modals/icons/head.svg"

function ChangeGivenDateModal({ open, onClose, date, onDateChange, onSubmit, loading }) {
    if (!open) return null

    return (
        <div className={open ? 'visible overlay' : 'overlay'}>
            <form className="show popup-primary small" autoComplete="off" onSubmit={onSubmit} style={{ display: open ? 'block' : 'none' }}>
                <div className='head-new'>
                    <img src={popupDefaultHeadImage} alt="icon" />
                    <div className='texts'>
                        <h2>
                            {trans('buttons.changeGivenDate')}
                        </h2>
                    </div>
                    <span className='close' onClick={onClose}>

                    </span>
                </div>

                <div className="row">
                    <div className="col">
                        <label>{trans('labels.givenDate')}</label>
                        <DatePicker
                            date={date || ''}
                            onDateChange={onDateChange}
                            disabled={loading}
                        />
                    </div>
                </div>

                <div className="footer align-right">
                    {loading ? (
                        <span>{trans('labels.loading')}</span>
                    ) : (
                        <>
                            <button className="button" type="button" onClick={onClose}>
                                {trans('buttons.cancel')}
                            </button>
                            <button className="button button-primary" type="submit">
                                {trans('buttons.save')}
                            </button>
                        </>
                    )}
                </div>
            </form>
        </div>
    )
}

export default ChangeGivenDateModal
